module.exports = __webpack_public_path__ + "img/morning-shake.b5092723.jpg";